module.exports = __webpack_public_path__ + "assets/img/Chama-Landing-Page-+-Website-w540.fb0afd50.jpg";